"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

var a11y = _interopRequireWildcard(require("@shopify/theme-a11y"));

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

var _bind = _interopRequireDefault(require("../mixins/bind"));

var _escEvent = _interopRequireDefault(require("../mixins/esc-event"));

var _overlay = _interopRequireDefault(require("../mixins/overlay"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Export default toggle module.
 */


var _default = function _default(config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    overlay: true,
    focusInput: true,
    appendOverlayTo: false
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  var namespace = config.namespace || config.targetSelector;
  var appendOverlayTo = settings.appendOverlayTo;
  /**
   * Node selectors.
   */

  var nodeSelectors = {
    toggleSelector: document.querySelectorAll("[js-toggle=\"".concat(config.toggleSelector, "\"]")),
    targetSelector: document.querySelectorAll("[js-toggle=\"".concat(config.targetSelector, "\"]"))
  };
  /**
   * Initialise component bind to prevent double binds.
   */

  var binder = (0, _bind["default"])(nodeSelectors.targetSelector, {
    className: 'toggle-set'
  });
  /**
   * Initiate component.
   */

  function init() {
    if (binder.isSet()) {
      return;
    }

    setToggleEvents();
    setListeners();
    binder.set();
  }
  /**
   * Set component listeners.
   */


  function setListeners() {
    Frame.EventBus.listen(['EscEvent:on', "Overlay:".concat(namespace, ":hide")], function () {
      close();
    });
  }
  /**
   * Set click events on toggle selectors.
   */


  function setToggleEvents() {
    _toConsumableArray(nodeSelectors.toggleSelector).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleToggleEvent(event);
      });
    });
  }
  /**
   * Handle toggle events.
   * @param {Event} event Click event.
   */


  function handleToggleEvent(event) {
    event.preventDefault();
    toggle();
  }
  /**
   * Toggle target component.
   */


  function toggle() {
    return isTargetActive() ? close() : open();
  }
  /**
   * Open target component and fire global open event.
   */


  function open() {
    addSelectorClasses();
    (0, _escEvent["default"])().set();
    focusTarget();

    if (settings.overlay) {
      (0, _overlay["default"])({
        namespace: namespace,
        appendOverlayTo: appendOverlayTo
      }).open();
    }

    Frame.EventBus.emit("Toggle:".concat(namespace, ":open"));
  }
  /**
   * Close target component and fire global close event.
   */


  function close() {
    removeSelectorClasses();
    unfocusTarget();

    if (settings.overlay) {
      (0, _overlay["default"])({
        namespace: namespace,
        appendOverlayTo: appendOverlayTo
      }).close();
    }

    Frame.EventBus.emit("Toggle:".concat(namespace, ":close"));
  }
  /**
   * Set toggle and target states active.
   */


  function addSelectorClasses() {
    _toConsumableArray(nodeSelectors.targetSelector).forEach(function (element) {
      element.classList.add(_cssClasses["default"].active);
    });

    _toConsumableArray(nodeSelectors.toggleSelector).forEach(function (element) {
      element.classList.add(_cssClasses["default"].active);
    });
  }
  /**
   * Remove active classes from all toggles and targets.
   */


  function removeSelectorClasses() {
    _toConsumableArray(nodeSelectors.targetSelector).forEach(function (element) {
      element.classList.remove(_cssClasses["default"].active);
    });

    _toConsumableArray(nodeSelectors.toggleSelector).forEach(function (element) {
      element.classList.remove(_cssClasses["default"].active);
    });
  }
  /**
   * Check if target is active.
   */


  function isTargetActive() {
    return _toConsumableArray(nodeSelectors.targetSelector).every(function (element) {
      return element.classList.contains(_cssClasses["default"].active);
    });
  }
  /**
   * Set a11y focus on first target.
   */


  function focusTarget() {
    if (settings.focusInput && targetHasInput(nodeSelectors.targetSelector[0])) {
      a11y.trapFocus(nodeSelectors.targetSelector[0].querySelector('input'));
      return;
    }

    a11y.trapFocus(nodeSelectors.targetSelector[0]);
  }
  /**
   * Check if focus has an input to focus on.
   */


  function targetHasInput(target) {
    return target.querySelector('input');
  }
  /**
   * Remove a11y focus on target.
   */


  function unfocusTarget() {
    a11y.removeTrapFocus(nodeSelectors.targetSelector[0]);
  }
  /**
   * Return immutable object.
   */


  return Object.freeze({
    init: init,
    open: open,
    close: close
  });
};

exports["default"] = _default;